import { Button, Dialog, DialogTitle, Grid, IconButton, TextField, Tooltip, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { WorkOrder } from '../../../models/workOrder';
import { ScheduleDialog } from '../workorders-tab/shedule.dialog';
import EditIcon from '@mui/icons-material/Edit';
import { Icons } from '../../../assets/icons';
import { FormSelect } from '../../../components/hook-form/form-select.component';
import { FormInput } from '../../../components/hook-form/form-input.component';
import { DateFormat, FormDateField } from '../../../components/hook-form/form-date.field.component';
import { FormCurrencyInput } from '../../../components/hook-form/form-currency-input.component';
import { ContactsListDialog } from '../../contacts/contacts-list.dialog';
import { FormCheckbox } from '../../../components/hook-form/form-checkbox.component';
import { useFormContext, useWatch } from 'react-hook-form';
import { FormAutoCompleteSelectDynamic } from '../../../components/hook-form/form-autocomplete-select.dynamic.component';
import { unitsApiKeyStore } from '../../../api/units-api-key-store';

import { ApiResponse } from '../../../models/api-response';
import { useLoadData } from '../../../hooks/useLoadData';
import { useSaveData } from '../../../hooks/useSaveData';
import { workOrdersApiKeyStore } from '../../../api/workorders-api-key-store';
import { LoadingIndicator } from '../../../components/loading-indicator.component';
import { ContactsDialogWithGridSelect } from '../../contacts/contact-diallog-with-grid-selection';
import { contactApiKeyStore } from '../../../api/contact-api-key-store';
import { Contact } from '../../../models/contact';
import { UserPermissionName } from '../../../models/user-permission-name';
import { useAuthorize } from '../../../hooks/use-authorize';
import { DialogActionsBar } from '@progress/kendo-react-dialogs';
import CloseIcon from '@mui/icons-material/Close';
import { GuardedComponent } from '../../../components/guarded-component';
import { useLocation } from 'react-router-dom';
import { WorkOrderLogDialog } from './work-order-log/work-order-logs-dialog';

interface EditWorkOrderForm {
  data?: WorkOrder;
  refetch?: () => void;
  onHandleOpenServiceDialog: () => void;
  onHandleOpenPurchaseOrderDialog: () => void;
  onHandleDownloadClick: () => void;
  onHandleOpenWODocumentDialog: () => void;
  onHandleOpenNoteDialog: () => void;
}
const styling = {
  labelStyle: { color: '#707070', fontSize: '14px', fontWeight: '600' },
  valueStyle: { color: '#000', fontWeight: '500', fontSize: '13px' },
  buttonStyle: { width: '130px' },
  warningStyle: { color: '#ff7000', fontWeight: '500', fontSize: '13px' },
};

interface HeaderValueCellProps {
  workOrder?: any;
  heading: string;
  value: any;
  isRequired?: boolean;
  hasPurchaseOrders?: boolean;
  fileType?: string;
  className?: string;
  reloadData?: any;
  handleOpenPurchaseOrderDialog?: () => void;
  handleDownloadClick?: () => void;
  setIsLoadingRules?: React.Dispatch<React.SetStateAction<boolean>>;
}

const HeaderValueCell = ({ heading, value, className }: HeaderValueCellProps) => {
  return (
    <Grid container spacing={0.5} className={className}>
      <Grid item lg={12} sm={12} xl={12} xs={12}>
        <Typography variant="body1" color="textPrimary" style={styling.labelStyle}>
          {heading}
        </Typography>
        <Typography variant="body1" className="custDesign" style={{ marginBottom: '6px' }}>
          {value ? value : '-'}
        </Typography>
      </Grid>
    </Grid>
  );
};

const InspectorData = ({
  workOrder,
  heading,
  value,
  className,
  reloadData,
  setIsLoadingRules,
}: HeaderValueCellProps) => {
  const [openSchedule, setOpenSchedule] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [openFFDispatchDialog, setOpenFFDispatchDialog] = useState(false);
  const ishavePermission = useAuthorize([UserPermissionName?.OVERRIDE]);
  const [currentWorkOrderID, setCurrentWorkOrderID] = useState(0);
  const [openDialogRule, setOpenDialogRule] = useState(false);
  const [scheduleRule, setScheduleDialogRule] = useState([]);
  const [pendingWorkOrder, setPendingWorkOrder] = useState([]);
  const { isLoading: sheduleRuleLoading, mutateAsync: sheduleRuleCheck } = useSaveData<any>(
    //workOrdersApiKeyStore.generateWorkOrderSheduleRules()
    workOrdersApiKeyStore.checkWorkOrderSheduleRules()
  );

  const handleScheduleClick = async (
    id: any, //showAirflowWarning: any,
    ffDispatchID: any,
    status: any
  ) => {
    // if (showAirflowWarning) {
    //   setCurrentWorkOrderID(id);

    //   handleOpenDialog();
    // }
    // else {
    //   const result = await sheduleRuleCheck({ data: { workOrderID: id } });
    //   setOpenSchedule(true);
    // }
    await sheduleRuleCheck({ data: { workOrderID: id } }).then((data) => {
      if (data?.data?.pendingRules?.length > 0) {
        setScheduleDialogRule(data?.data?.pendingRules || []);
        setPendingWorkOrder(data?.data?.preReqWorkOrders || []);
        setOpenDialogRule(true);
      } else {
        setOpenSchedule(true);
      }
    });
  };

  useEffect(() => {
    setIsLoadingRules?.(sheduleRuleLoading);
  }, [sheduleRuleLoading]);

  const handleScheduleClose = () => {
    setOpenSchedule(false);
  };
  const handleSaveComplete = () => {
    reloadData?.();
  };

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const closeDialog = () => {
    setOpenDialog(false);
  };
  const closeDialogRule = () => {
    setScheduleDialogRule([]);
    setPendingWorkOrder([]);
    setOpenDialogRule(false);
  };
  const closeFFDispatchDialog = () => {
    setOpenFFDispatchDialog(false);
  };
  const handleSumbitConfirm = async () => {
    const result = await sheduleRuleCheck({ data: { workOrderID: currentWorkOrderID } });
    closeDialog();
    setOpenSchedule(true);
  };
  const handleSumbitRuleConfirm = async () => {
    setScheduleDialogRule([]);
    setPendingWorkOrder([]);
    setOpenDialogRule(false);
    setOpenSchedule(true);
  };
  const handleSumbitConfirmFFDispatch = async () => {
    const result = await sheduleRuleCheck({ data: { workOrderID: currentWorkOrderID } });
    closeFFDispatchDialog();
    setOpenSchedule(true);
  };

  const isReadOnlyPermission = useAuthorize([UserPermissionName?.READ_ONLY]);

  return (
    <Grid container spacing={0.5} className={className}>
      <div
        //  onClick={
        //   workOrder.canSchedule
        //     ? (workOrder?.workOrderStatus === 'Scheduled' && !workOrder.ffDispatchID)
        //       ? () => {}
        //       : () => handleScheduleClick(workOrder?.workOrderID, workOrder?.showAirflowWarning,workOrder?.ffDispatchID,workOrder?.workOrderStatus)
        //     : () => {}
        //   }
        onClick={
          workOrder.canSchedule
            ? () =>
              handleScheduleClick(
                workOrder?.workOrderID,
                //workOrder?.showAirflowWarning,
                workOrder?.ffDispatchID,
                workOrder?.workOrderStatus
              )
            : () => { }
        }
        style={{ cursor: 'pointer', width: '100%', display: 'flex', flexDirection: 'column', paddingTop: '4px' }}
      >
        <Grid item lg={12} sm={12} xl={12} xs={12} className="d-flex">
          <Typography variant="body1" color="textPrimary" style={styling.labelStyle}>
            {heading}
          </Typography>
          {workOrder?.canSchedule && (
            <Button
              style={{ marginLeft: 'auto', padding: '0', minWidth: 'auto', marginRight: '10px', marginTop: '5px' }}
            >
              <Tooltip
                title={
                  // <Typography variant="body1">{!workOrder?.scheduledDate ? 'Schedule' : (workOrder?.workOrderStatus === "Scheduled" && !workOrder.ffDispatchID && workOrder.isFastFieldRetest && workOrder.fastFieldFormID!==0) ?'This work order has not been dispatched to Fastfield yet.' : 'Reschedule'}</Typography>
                  <Typography variant="body1">{!workOrder?.scheduledDate ? 'Schedule' : 'Reschedule'}</Typography>
                }
              >
                <img src={Icons.scheduleCalendar} alt="Schedule" />
              </Tooltip>
            </Button>
          )}
        </Grid>
        <Grid item lg={12} sm={12} xl={12} xs={12} style={{ minHeight: '24px' }}>
          <Typography variant="body1" color="text.secondary" style={styling.valueStyle}>
            {value ? value : '-'}
          </Typography>
        </Grid>
      </div>
      {openSchedule && (
        <ScheduleDialog workOrder={workOrder} onClose={handleScheduleClose} onSaveCompleted={handleSaveComplete} />
      )}
      <>
        {openDialog && (
          <Dialog
            open={openDialog}
            className="modalpopup"
            title={'CONFIRM STATUS'}
          //  onClose={closeDialog}
          >
            <div>
              <div style={{ padding: '25px 50px' }}>
                <div>
                  {ishavePermission
                    ? 'The airflow value is not greater than zero. Are you sure you want to continue?'
                    : 'The airflow value is not greater than zero. You do not have permission to schedule.'}
                </div>
                <LoadingIndicator isLoading={sheduleRuleLoading} />
              </div>
            </div>
            <DialogActionsBar>
              <div className=" spaceBetween">
                <button
                  style={{ cursor: 'pointer' }}
                  className="btn btn-sm btn-default btn-lightGrey"
                  onClick={closeDialog}
                  autoFocus
                >
                  Cancel
                </button>
                {ishavePermission && (
                  <button
                    className="btn btn-sm btn-primary  btn-delete"
                    style={{
                      backgroundColor: isReadOnlyPermission ? '#d7dbdd' : '#0000b5',
                      color: isReadOnlyPermission ? 'black' : '#fff',
                      cursor: 'pointer'
                    }}
                    type="button"
                    onClick={handleSumbitConfirm}
                    disabled={sheduleRuleLoading || isReadOnlyPermission}
                  >
                    Confirm
                  </button>
                )}
              </div>
            </DialogActionsBar>
          </Dialog>
        )}
        {openDialogRule && (
          <Dialog
            open={openDialogRule}
            className="modalpopup"
            title={'CONFIRM STATUS'}
          // onClose={closeDialog}
          >
            <div>
              <div style={{ padding: '25px 50px' }}>
                <div>
                  <h4>Please see the below validations</h4>
                  <br></br>
                  <ul>{scheduleRule?.map((data: any) => <li key={data}>{data}</li>)}
                    {pendingWorkOrder?.length > 0 && (
                      <dl>
                        <dt>Pending Work Orders:</dt>
                        {pendingWorkOrder?.map((data: any) => <dd key={data}>- {data}</dd>)}
                      </dl>
                    )}
                  </ul>
                </div>
                <br></br>
                <div>
                  {ishavePermission ? (
                    <h5>
                      You have the permission to schedule without completing the validations. Are you sure you want to
                      continue?
                    </h5>
                  ) : (
                    <h5>You do not have the permission to schedule without completing the validations.</h5>
                  )}
                </div>
                <LoadingIndicator isLoading={sheduleRuleLoading} />
              </div>
            </div>
            <DialogActionsBar>
              <div className=" spaceBetween">
                <button
                  style={{ cursor: 'pointer' }}
                  className="btn btn-sm btn-default btn-lightGrey"
                  onClick={closeDialogRule}
                  autoFocus
                >
                  Cancel
                </button>
                {ishavePermission && (
                  <button
                    className="btn btn-sm btn-primary  btn-delete"
                    style={{
                      backgroundColor: isReadOnlyPermission ? '#d7dbdd' : '#0000b5',
                      color: isReadOnlyPermission ? 'black' : '#fff',
                      cursor: 'pointer'
                    }}
                    type="button"
                    onClick={handleSumbitRuleConfirm}
                    disabled={sheduleRuleLoading || isReadOnlyPermission}
                  >
                    Confirm
                  </button>
                )}
              </div>
            </DialogActionsBar>
          </Dialog>
        )}
      </>
      <>
        {openFFDispatchDialog && (
          <Dialog
            open={openFFDispatchDialog}
            className="modalpopup"
            title={'CONFIRM STATUS'}
          // onClose={closeDialog}
          >
            <div>
              <div style={{ padding: '25px 50px' }}>
                <div>
                  This work order is waiting for Fastfield results. Please cross-check the work order status from the
                  Fastfield before reschedule. Do you want to continue?
                </div>
                <LoadingIndicator isLoading={sheduleRuleLoading} />
              </div>
            </div>
            <DialogActionsBar>
              <div className=" spaceBetween">
                <button
                  style={{ cursor: 'pointer' }}
                  className="btn btn-sm btn-default btn-lightGrey"
                  onClick={closeFFDispatchDialog}
                  autoFocus
                >
                  Cancel
                </button>

                <button
                  className="btn btn-sm btn-primary  btn-delete"
                  style={{
                    backgroundColor: isReadOnlyPermission ? '#d7dbdd' : '#0000b5',
                    color: isReadOnlyPermission ? 'black' : '#fff',
                    cursor: 'pointer'
                  }}
                  type="button"
                  onClick={handleSumbitConfirmFFDispatch}
                  disabled={sheduleRuleLoading || isReadOnlyPermission}
                >
                  Confirm
                </button>
              </div>
            </DialogActionsBar>
          </Dialog>
        )}
      </>
    </Grid>
  );
};

const PurchaseOrderData = ({
  heading,
  value,
  isRequired,
  hasPurchaseOrders,
  fileType,
  className,
  handleOpenPurchaseOrderDialog,
  handleDownloadClick,
}: HeaderValueCellProps) => {
  return (
    <Grid container spacing={0.5} className={className}>
      <div className="bgWhite">
        <Grid item lg={12} sm={12} xl={12} xs={12}>
          <Typography
            variant="body1"
            color="textPrimary"
            style={{
              color: '#000',
              fontWeight: '500',
              fontSize: '13px',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
            className="d-flex flex-row"
          >
            <div className="d-flex flex-column">
              <span>Purchase Order</span>
              <div className="d-flex" style={{ alignItems: 'center' }}>
                <span> {!isRequired ? ' ( Not Required )' : ' ( Required )'}</span>
                {hasPurchaseOrders && (
                  <Tooltip title={<Typography variant="body1">Purchase Order Added</Typography>}>
                    <img src={Icons.IconCheckFillGreen} />
                  </Tooltip>
                )}
              </div>
            </div>
            <GuardedComponent requiredPermissions={[UserPermissionName.VIEW_PO_WORKORDER]}>
              <Button
                className="btn btn-xs btn-primary"
                onClick={handleOpenPurchaseOrderDialog}
              // style={{ marginLeft: '10px', padding: '0', minWidth: 'auto', marginRight: '10px', marginTop: '5px' }}
              >
                <span>{/* {heading} */} View/ Upload PO</span>{' '}
              </Button>
            </GuardedComponent>
          </Typography>
        </Grid>
      </div>
    </Grid>
  );
};

const EditWorkOrderForm = ({
  data,
  refetch,
  onHandleDownloadClick,
  onHandleOpenNoteDialog,
  onHandleOpenPurchaseOrderDialog,
  onHandleOpenServiceDialog,
  onHandleOpenWODocumentDialog,
}: EditWorkOrderForm) => {
  const [isDialogVisible, setIsDialogVisible] = useState(false);
  const [isDialogVisibleForLog, setIsDialogVisibleForLog] = useState(false);
  const { setValue, reset, watch } = useFormContext();
  const [isLoadingRules, setIsLoadingRules] = useState<boolean>(false);
  const [valueForTab, setValueForTab] = useState('view');
  const [isOpenReason, setIsOpenReason] = useState(false);
  const [reason, setReason] = useState<string>('');
  const [reasonError, setReasonError] = useState<boolean>(false);
  const [editItem, setEditItem] = useState<Contact>();
  const { data: permitData } = useLoadData<ApiResponse<any>>(unitsApiKeyStore.getUnitPermitType(data?.unitID));
  const { isLoading, mutateAsync } = useSaveData(workOrdersApiKeyStore.updateReasonForFeeWaived());
  const isDisableFeeWaived = useAuthorize([UserPermissionName.FEE_WAIVING]);

  const location = useLocation();
  const pageForm = location.state?.page;
  useEffect(() => {
    if (data) {
      const updatedData = {
        ...data,
        permitType: {
          permitType: data?.permitType,
          permitTypeText: !permitData?.data
            ? ''
            : permitData?.data?.find((item: any) => item.permitType === data.permitType)?.permitTypeText || '',
        },
      };
      reset(updatedData);
      setValue('inspectionReportUploaded', data?.inspectionReportUploaded);
      setValue('feeWaived', data?.feeWaived);
      setValue('isActive', data?.isActive);
      // setValue('permitType', { permitType: data?.permitType });
    }
  }, [data, permitData]);

  const watchFeeWaived = watch('feeWaived');

  const handleOpenPurchaseOrderDialog = () => {
    onHandleOpenPurchaseOrderDialog();
  };
  const handleDownloadClick = () => {
    onHandleDownloadClick();
  };
  const handleOpenWODocumentDialog = () => {
    onHandleOpenWODocumentDialog();
  };
  const handleOpenNoteDialog = () => {
    onHandleOpenNoteDialog();
  };

  const handleCloseAddContactForm = (contacts: Contact[]) => {
    setIsDialogVisible(false);
  };

  const handleCloseWorkOrderLog = () => {
    setIsDialogVisibleForLog(false);
  };

  const handleFeeWaivedChange = (event: any, checked: boolean) => {
    if (checked) {
      setIsOpenReason(true);
    }
  };

  const closeDialogReason = () => {
    setIsOpenReason(false);
    setValue('feeWaived', false);
    setReason('');
  };

  const handleSaveClick = async () => {
    if (!reason.trim()) {
      setReasonError(true);
      return;
    }
    await mutateAsync({
      data: {
        workOrderID: data?.workOrderID,
        feeWaivedReason: reason,
      },
    }).then((data) => {
      setValue('feeWaived', true);
      refetch?.();
      setIsOpenReason(false);
    });
  };

  const handleOpenServiceDialog = () => {
    onHandleOpenServiceDialog();
  };

  const isReadOnlyPermission = useAuthorize([UserPermissionName?.READ_ONLY]);
  const isSetActiveInactivePermission = useAuthorize([UserPermissionName?.SET_ACTIVE_INACTIVE]);

  return (
    <>
      <Grid item lg={9} className="woRightSection">
        {isLoadingRules && <LoadingIndicator isLoading={isLoadingRules} />}
        <div className="d-flex" style={{ paddingTop: '0px', paddingBottom: '2px', gap: '12px' }}>
          <div style={{ display: 'flex', flex: '1' }}>
            <HeaderValueCell className="bgWhite normalPad mZ" heading="Work Order#" value={data?.workOrderNumber} />
          </div>
          <div style={{ display: 'flex', flex: '1' }}>
            <HeaderValueCell className="bgWhite normalPad mZ" heading="Jobsite" value={data?.jobsite} />
          </div>
          <div style={{ display: 'flex', flex: '1' }}>
            <HeaderValueCell className="bgWhite normalPad mZ" heading="Lot/Unit#" value={data?.unitName} />
          </div>
          <div style={{ display: 'flex', flex: '1' }}>
            <HeaderValueCell className="bgWhite normalPad mZ" heading="Builder Job Number" value={data?.jobNumber} />
          </div>
          <div style={{ display: 'flex', flex: '1' }}>
            <HeaderValueCell className="bgWhite normalPad mZ" heading="Address" value={data?.address} />
          </div>
        </div>
        <div className="d-flex" style={{ paddingTop: '10px', paddingBottom: '10px', gap: '12px' }}>
          <div style={{ display: 'flex', flex: '1' }}>
            <HeaderValueCell className="bgWhite normalPad mZ" heading="Customer" value={data?.customerName} />
          </div>
          <div style={{ display: 'flex', flex: '1' }}>
            <HeaderValueCell className="bgWhite normalPad  mZ" heading="Office" value={data?.officeName} />
          </div>
          <div style={{ display: 'flex', flex: '1' }}>
            <HeaderValueCell className="bgWhite normalPad  mZ" heading="Project" value={data?.projectName} />
          </div>
          <div style={{ display: 'flex', flex: '1' }}>
            <HeaderValueCell className="bgWhite normalPad  mZ" heading="Project Code" value={data?.projectCode} />
          </div>
        </div>
      </Grid>
      <Grid container justifyContent="space-between" spacing={1}>
        <Grid item xl={8} lg={8} sm={6} xs={12}>
          <Grid container className="   normalPad bgWhite" style={{ marginBottom: '10px' }}>
            <Grid item lg={6}>
              <HeaderValueCell className="bgWhite" heading="Service Category" value={data?.serviceCategoryName} />
            </Grid>
            <Grid item lg={6} className="d-flex">
              <HeaderValueCell className="bgWhite" heading="Service  " value={data?.serviceCode} />
              {data?.canEdit && data?.isWOServiceEditable && (
                <Tooltip title={<Typography variant="body1">Switch Service</Typography>}>
                  <EditIcon
                    style={{ cursor: 'pointer', color: 'blue' }}
                    className="btnEdit"
                    onClick={handleOpenServiceDialog}
                  />
                </Tooltip>
              )}
            </Grid>
            <Grid item lg={6}>
              <HeaderValueCell className="bgWhite" heading="Billing Type" value={data?.billingType} />
            </Grid>
            {data?.bundleService && (
              <>
                <Grid item lg={6}>
                  <HeaderValueCell className="bgWhite" heading="Bundle Name" value={data?.bundleName} />
                </Grid>
                <Grid item lg={6}>
                  <HeaderValueCell className="bgWhite" heading="Bundle Price ($)" value={data?.bundlePrice} />
                </Grid>
                <Grid item lg={6}>
                  <HeaderValueCell className="bgWhite" heading="Split Name" value={data?.splitName} />
                </Grid>
                <Grid item lg={6}>
                  <HeaderValueCell className="bgWhite" heading="Split Amount ($)" value={data?.splitAmt} />
                </Grid>
              </>
            )}

            <Grid item lg={6} paddingRight={2} style={{ marginTop: '8px' }}>
              <FormCurrencyInput
                label="Invoice Amount ($)"
                name="invoiceAmount"
                disabled={!pageForm ? !data?.canEditPrice : false}
              />
              {!pageForm && data?.invoiceGenerated ? (
                <span style={styling.warningStyle}>Note: If invoice needs to be changed, contact accounting.</span>
              ) : (
                ''
              )}
            </Grid>
            <Grid item lg={6}>
              <HeaderValueCell className="bgWhite" heading="Accrual Amount ($)" value={data?.accrualAmount} />
            </Grid>
            <Grid item lg={6}>
              <FormCheckbox
                onChange={handleFeeWaivedChange}
                label="Fee Waived"
                name="feeWaived"
                disabled={!data?.canEditPrice || !isDisableFeeWaived || !!watchFeeWaived}
              />
            </Grid>
          </Grid>

          {!!data?.feeWaivedReason && (
            <Grid container spacing={1} style={{ marginBottom: '10px', paddingRight: '4px' }}>
              <Grid item xl={12} lg={12} sm={12} xs={12} className="d-flex">
                <Grid lg={6}>
                  <HeaderValueCell
                    className="bgWhite  normalPad noMar"
                    heading="Fee Waived Reason"
                    value={data?.feeWaivedReason}
                  />
                </Grid>
                <Grid lg={6}>
                  <HeaderValueCell
                    className="bgWhite  normalPad noMar"
                    heading="Fee Waived By"
                    value={data?.feeWaivedBy}
                  />
                </Grid>
                <Grid lg={6}>
                  <HeaderValueCell
                    className="bgWhite  normalPad noMar"
                    heading="Fee Waived On"
                    value={data?.feeWaivedOn}
                  />
                </Grid>
              </Grid>
            </Grid>
          )}

          {/* -------------------- */}
          <Grid container className="  normalPad bgWhite">
            <Grid item lg={6}>
              <HeaderValueCell className="bgWhite" heading="Status" value={data?.workOrderStatus} />
            </Grid>

            <Grid item lg={6}>
              <div className="d-flex flex-column" style={{ flex: '1', paddingTop: '0' }}>
                <InspectorData
                  className="bgWhite"
                  heading="Inspector"
                  value={data?.inspectorName}
                  workOrder={data}
                  reloadData={refetch}
                  setIsLoadingRules={setIsLoadingRules}
                />
              </div>
            </Grid>
            <Grid item lg={6}>
              <HeaderValueCell className="bgWhite" heading="Permit Number" value={data?.permitNumber} />
            </Grid>
            {data?.workOrderStatus !== 'Ready' && (
              <Grid item lg={6}>
                <HeaderValueCell heading="Scheduled Date " value={data?.scheduledDate} />
              </Grid>
            )}
            {data?.workOrderStatus === 'Ready' && (
              <Grid item lg={6}>
                <HeaderValueCell heading="Proposed Schedule Date " value={data?.proposedScheduledDate} />
              </Grid>
            )}
            <Grid item lg={6}>
              <HeaderValueCell heading="Completed Date" value={data?.completedOn} />
            </Grid>
            <Grid item lg={6}>
              <HeaderValueCell heading="Canceled Date" value={data?.cancelledOn} />
            </Grid>
          </Grid>

          <Grid container className=" normalPad bgWhite" style={{ marginBottom: '10px', marginTop: '10px' }}>
            <Grid item lg={6}>
              <FormCheckbox disabled={!data?.canEditUploadedInspectionRpt}
                label="Uploaded The Inspection Report To The Municipalities Online Permitting System"
                name="inspectionReportUploaded"
              />
            </Grid>
            {isSetActiveInactivePermission && (
              <Grid item lg={6}>
                <FormCheckbox disabled={!data?.canEditActiveStatus}
                  label="Active"
                  name="isActive"
                />
              </Grid>
            )}
          </Grid>
          {/* {----------------------------------} */}
        </Grid>

        <Grid item xl={4} lg={4} sm={6} xs={6} style={{ padding: '10px 0 0 12px' }}>
          <Grid className="bgWhite  normalPad">
            <Grid item lg={6}>
              <HeaderValueCell heading="Invoice #" value={data?.invoiceNo} />
            </Grid>
            <Grid item lg={6}>
              <HeaderValueCell heading="Invoice Date" value={data?.invoiceDate} />
            </Grid>
            <Grid item lg={6}>
              <HeaderValueCell heading="Invoice Due Date" value={data?.invoiceDueDate} />
            </Grid>
          </Grid>
          {/* <Grid item xl={4} lg={4} sm={6} xs={6}> */}
          {data?.canEdit && data?.canEditPO && (
            <Grid className="bgWhite normalPad">
              {/* <div style={{ display: 'flex', flex: '1' }}> */}
              <PurchaseOrderData
                heading="Purchase Order"
                value={data?.purchaseOrderNo}
                isRequired={data?.requirePurchaseOrder}
                hasPurchaseOrders={data?.hasPurchaseOrders}
                fileType={data?.fileType}
                handleOpenPurchaseOrderDialog={handleOpenPurchaseOrderDialog}
                handleDownloadClick={handleDownloadClick}
              />
              {/* </div> */}
            </Grid>
          )}
          {/* </Grid> */}
          <div className="d-flex">
            {data?.canEdit && data?.canEditContactFileNote && (
              <Grid style={{ marginTop: '15px' }}>
                <GuardedComponent requiredPermissions={[UserPermissionName.VIEW_NOTE]}>
                  <Button className="btn btn-primary" variant="outlined" onClick={handleOpenNoteDialog}>
                    ADD NOTES
                  </Button>
                </GuardedComponent>
                <Button
                  className="btn btn-primary"
                  style={{ marginLeft: 10 }}
                  variant="outlined"
                  onClick={handleOpenWODocumentDialog}
                >
                  FILE UPLOAD
                </Button>
              </Grid>
            )}
            {data?.canEdit && data?.canEditContactFileNote && (
              <Grid style={{ marginTop: '15px' }}>
                <Button
                  className="btn btn-primary"
                  style={{ marginLeft: 10 }}
                  variant="outlined"
                  onClick={() => {
                    setIsDialogVisible(true);
                    setValueForTab('view');
                  }}
                >
                  View/ Add Contacts
                </Button>
              </Grid>
            )}
            {/* <Grid style={{ marginTop: '15px' }}>
              <Button
                className="btn btn-primary"
                style={{ marginLeft: 10 }}
                variant="outlined"
                onClick={() => {
                  setIsDialogVisibleForLog(true);
                }}
              >
                View Logs
              </Button>
            </Grid> */}
          </div>

          <div className="d-flex">
            <Grid style={{ marginTop: '15px' }}>
              <Button
                className="btn btn-primary"
                style={{}}
                variant="outlined"
                onClick={() => {
                  setIsDialogVisibleForLog(true);
                }}
              >
                View Logs
              </Button>
            </Grid>
          </div>
        </Grid>
        {isDialogVisible && (
          <ContactsDialogWithGridSelect
            open={isDialogVisible}
            onClose={handleCloseAddContactForm}
            contacts={[]}
            customerID={''}
            setValue={setValueForTab}
            value={valueForTab}
            editItem={editItem}
            setEditItem={setEditItem}
            watchKeys={['office.officeID']}
            getQueryKeyConfig={() => contactApiKeyStore.getUnitContacts(data?.unitID)}
            page="workOrderList"
            itemId={!data?.unitID ? '' : String(data?.unitID)}
          />
        )}
      </Grid>
      {!!data?.resultChangeReason && (
        <Grid container spacing={1} style={{ marginBottom: '16px', paddingRight: '8px' }}>
          <Grid item xl={8} lg={8} sm={6} xs={12} className="d-flex">
            <Grid lg={6}>
              <HeaderValueCell
                className="bgWhite  normalPad noMar"
                heading="Result Change Reason"
                value={data?.resultChangeReason}
              />
            </Grid>
            <Grid lg={6}>
              <HeaderValueCell
                className="bgWhite  normalPad noMar"
                heading="Result Changed By"
                value={data?.resultChangedBy}
              />
            </Grid>
            <Grid lg={6}>
              <HeaderValueCell
                className="bgWhite  normalPad noMar"
                heading="Result Changed On"
                value={data?.resultChangedOn}
              />
            </Grid>
          </Grid>
        </Grid>
      )}{' '}
      {isOpenReason && (
        <Dialog
          open={isOpenReason}
          className="modalpopup"
          title={'REASON'}
          // onClose={closeDialogReason}
          maxWidth={'md'}
          fullWidth={true}
        >
          <DialogTitle id="alert-dialog-title" sx={{ p: 2, pt: 1, pb: 1, m: 0 }}>
            Reason
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={closeDialogReason}
            sx={{
              position: 'absolute',
              right: 10,
              top: 3,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Tooltip title={<Typography variant="body1">Close</Typography>}>
              <CloseIcon />
            </Tooltip>
          </IconButton>
          <div style={{ padding: '15px 30px' }}>
            <TextField
              id="reason"
              label="Reason for fee waived"
              multiline
              rows={4}
              variant="outlined"
              value={reason}
              onChange={(e: any) => {
                setReason(e.target.value);
                setReasonError(false);
              }}
              error={reasonError}
              helperText={reasonError ? 'Reason is required' : ''}
              fullWidth
              margin="normal"
            />
          </div>
          {isLoading && <LoadingIndicator isLoading={isLoading} />}
          <DialogActionsBar>
            <div className=" spaceBetween">
              <button
                style={{ cursor: 'pointer' }}
                className="btn btn-sm btn-default btn-lightGrey"
                onClick={closeDialogReason}
                autoFocus
              >
                Cancel
              </button>
              <button
                className="btn btn-sm btn-primary  btn-delete"
                style={{
                  backgroundColor: isReadOnlyPermission ? '#d7dbdd' : '#0000b5',
                  color: isReadOnlyPermission ? 'black' : '#fff',
                  cursor: 'pointer'
                }}
                type="button"
                onClick={handleSaveClick}
                disabled={isLoading || isReadOnlyPermission}
              >
                Save
              </button>
            </div>
          </DialogActionsBar>
        </Dialog>
      )}
      {isDialogVisibleForLog && <WorkOrderLogDialog onClose={handleCloseWorkOrderLog} open={isDialogVisibleForLog} />}
    </>
  );
};

export default EditWorkOrderForm;
